export default __webpack_public_path__ + "static/media/red2.09ba8cc3.png";